import { render, staticRenderFns } from "./TaksitlendirmeForm.vue?vue&type=template&id=fbdb5c90&scoped=true"
import script from "./TaksitlendirmeForm.vue?vue&type=script&lang=ts"
export * from "./TaksitlendirmeForm.vue?vue&type=script&lang=ts"
import style0 from "./TaksitlendirmeForm.vue?vue&type=style&index=0&id=fbdb5c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdb5c90",
  null
  
)

export default component.exports